import { VIDEO_FILE_EXTENSION_REGEX } from 'components/flowBuilder/constants/files';
import styled from 'styled-components';
import { isContactCardURL } from 'utils/contactCards';

export const isStaticImageURL = (mediaUrl: string) =>
  (mediaUrl.startsWith('http') || mediaUrl.startsWith('data:image/')) &&
  !isContactCardURL(mediaUrl) &&
  !VIDEO_FILE_EXTENSION_REGEX.test(mediaUrl);

const StyledStaticImage = styled.img`
  display: block;
  max-height: 300px;
  max-width: 100%;
`;

interface StaticImagePreviewProps {
  url: string;
}

const StaticImagePreview = ({ url }: StaticImagePreviewProps): JSX.Element => {
  return <StyledStaticImage alt="Image preview" src={url} />;
};

export default StaticImagePreview;
